import React, { useEffect, useState } from "react";
import { Form, FormikProvider, useFormik } from "formik";
import { Autocomplete, Box, Button, Stack, TextField } from "@mui/material";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import { useSelector } from "react-redux";
import {
  assignBatchToCro,
  changeBatchStatus,
  getBatchesList,
  getCROList,
  getTutorsList,
} from "../../redux/features/batchSlice";
import { Icon } from "@iconify/react/dist/iconify.js";
import GlobalDialog from "../../components/mui/Dialogue/GlobalDialog";
import GlobalSelectField from "../../components/mui/GlobalSelectField";
import * as Yup from "yup";

const AssignCro = ({ rowData, dispatchData, open, setOpen }) => {
  // const [open, setOpen] = useState(false);

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { loading, crolist } = useSelector((state) => state.batch);

  const validationSchema = Yup.object().shape({
    cro_id: Yup.string().required("Choose a CRO"),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      cro_id: rowData?.cro_assigned || "",
      batchID: rowData?.course_batch_id,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      dispatch(assignBatchToCro(values)).then((res) => {
        if (res.payload.status === "success") {
          enqueueSnackbar(res.payload.message, {
            variant: "success",
          });
          dispatch(getBatchesList(dispatchData));
          setOpen(false);
        } else {
          enqueueSnackbar(res.payload.message, {
            variant: "error",
          });
          // setOpen(false);
        }
      });
    },
  });

  useEffect(() => {
    if (open) {
      dispatch(getCROList());
    }
  }, []);

  return (
    <GlobalDialog
      title={"Assign Cro"}
      open={open}
      setOpen={setOpen}
      fullWidth
      maxWidth={"xs"}
      closeButton={true}
      content={
        <>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <Box>
                <Stack direction={"column"} spacing={2}>
                  <Autocomplete
                    name="cro_id"
                    fullWidth
                    options={crolist}
                    getOptionLabel={(option) => option.name || ""}
                    onChange={(event, newValue) => {
                      formik.setFieldValue("cro_id", newValue?.userID || "");
                    }}
                    value={
                      crolist.find(
                        (cro) => cro.userID === formik.values.cro_id
                      ) || null
                    }
                    renderInput={(params) => (
                      <TextField
                        fullWidth
                        autoComplete="off"
                        {...params}
                        label="CRO"
                        error={
                          formik.touched.cro_id && Boolean(formik.errors.cro_id)
                        }
                        helperText={
                          formik.touched.cro_id && formik.errors.cro_id
                        }
                      />
                    )}
                  />
                </Stack>
                <Box
                  sx={{ display: "flex", justifyContent: "flex-end", pt: 2 }}
                >
                  <Stack direction={"row"} spacing={1}>
                    <Button
                      size="small"
                      variant="outlined"
                      color="secondary"
                      onClick={() => setOpen(false)}
                    >
                      Cancel
                    </Button>
                    <Button
                      disabled={loading}
                      variant="contained"
                      color="secondary"
                      size="small"
                      type="submit"
                    >
                      {loading ? "Please wait..." : "Assign"}
                    </Button>
                  </Stack>
                </Box>
              </Box>
            </Form>
          </FormikProvider>
        </>
      }
    />
  );
};

export default AssignCro;
